import {useQueries} from "@tanstack/react-query";
import {AgentPresence, useAllPresentAgents, watchAgentPresenceByIdTqo} from "../rpc/webrpc-client.gen.ts";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";
import {mergeUseQueriesWithInfill} from "../tq/mergeUseQueriesWithInfill.tsx";
import {errorize} from "../bomb/errorize.tsx";
import {cleanse, NADA} from "../util/arutil.tsx";
import {useMothership} from "../tq/tqx.tsx";

export function useActiveAgentPresences(): InfallibleUseResult<AgentPresence[]> {
    const mama = useMothership();
    const stubTqrv = useAllPresentAgents();
    const prezTqrvs = useQueries(
        stubTqrv.data
            ? {
                queries: stubTqrv.data.map(astub =>
                    watchAgentPresenceByIdTqo(mama, {agentId: astub.id})),
                combine: mergeUseQueriesWithInfill,
            } : {queries: NADA});
    if (prezTqrvs.isPending) {
        return pendingUseResult;
    }
    if (prezTqrvs.isError) {
        throw errorize(prezTqrvs.errors);
    }
    return successUseResult(cleanse(prezTqrvs.data));
}

function isOnDuty(presence: AgentPresence) {
    if (presence.lastShiftEventFlavor !== "SHIFT_START" &&
        presence.lastShiftEventFlavor !== "BREAK_END") {
        return false;
    }
    const noutlets = presence.outlets.length;
    return noutlets > 0;
}

export function isAnybodyOnDuty(crew?: AgentPresence[]) {
    if (!crew) {
        return false;
    }
    for (const maybe of crew) {
        if (isOnDuty(maybe)) {
            return true;
        }
    }
    return false;
}
